Librarian.OnBehalfWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["loginOnBehalf"],

    options: {
        id: "OnBehalfWindow",
        width: 625,
        height: 570
    },

    grid: null,
    currentFilter: null,

    initialize: function(options) {
        this.setOptions(options);

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("login_on_behalf");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/onbehalf.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();

        this.setupElements();

        function doFilter() {
            var value = (Librarian.Utils.getElementValue(this.getElement("behalfSearchBox")) || '').trim(),
                url = null;
            // Add the "name" parameter if we have a filter
            if (value.length > 0)
                url = this.grid.options.url + "&name=" + encodeURIComponent(value);

            this.grid.loadData(url);
        }

        var itemEl = this.getElement("behalfSearchBox");
        if (itemEl) {
            itemEl.addEvent("keypress", function(e) {
                var evt = new Event(e);
                if (evt.keyCode == 13) {
                    doFilter.bind(this)();
                    evt.stop();
                    return false;
                }
            }.bind(this));
        }

        itemEl = this.getElement("behalfSearchButton");
        if (itemEl)
            itemEl.addOnClick(doFilter, this);

        itemEl = this.getElement("behalfCloseButton");
        if (itemEl) {
            itemEl.show();
            itemEl.addOnClick(this.close);
        }

        var self = this,
            filterEls = $$("a.filterLetter");
        for (var i = 0; i < filterEls.length; i++) {
            filterEls[i].addOnClick(function() {
                // Reset to the filter box to make it clear that is not being used
                Librarian.Utils.setElementValue(self.getElement("behalfSearchBox"), '');

                var term = this.get("text");
                if (term == "All")
                    term = null;

                self.currentFilter = term;

                // If there is a grid, reload it with the new data
                if (self.grid) {
                    var url = null;
                    // Add the "name" parameter if we have a filter
                    if (self.currentFilter != null)
                        url = self.grid.options.url + "&name=" + encodeURIComponent(self.currentFilter + '%');

                    // Reset the current page so we don't load page 2 of 1
                    self.grid.options.page = 1;

                    self.grid.loadData(url);
                }
            });
        }

        itemEl = this.getElement("behalfGrid");
        if (itemEl) {
            var gridOptions = this.getGridOptions();

            this.grid = new omniGrid(itemEl.id, gridOptions);

            this.grid.addEvent("dblclick", this.loginOnBehalf);
        }
    },

    getGridOptions: function() {
        var self = this;

        var url = this.getUrl();
        var columnModel = this.getColumnModel();

        var gridOptions = {
            url: url,
            columnModel: columnModel,
            resizable: false,
            pagination: true,
            serverSort: true,
            sortHeader: true,
            perPage: 20,
            width: 600,
            height: this.options.height - 100,
            pageChangeHandler: function(grid /*, page, pages, perPage*/) {
                var url = null;
                // Add the "name" parameter if we have a filter
                if (self.currentFilter != null)
                    url = grid.options.url + "&name=" + encodeURIComponent(self.currentFilter) + "%";

                grid.loadData(url);
            },
            customSortHandler: function(grid, sortOn, sortBy) {
                grid.options.sortOn = sortOn;
                grid.options.sortBy = sortBy;

                var url = null;
                // Add the "name" parameter if we have a filter
                if (self.currentFilter != null)
                    url = grid.options.url + "&name=" + encodeURIComponent(self.currentFilter) + "%";

                grid.loadData(url);
                return true;
            }
        };

        return gridOptions;
    },

    getUrl: function() {
        var url = Librarian.path.getMethodUrl("getusers") + "&out=dgrid";

        return url;
    },

    getColumnModel: function() {
        var columnModel = [
            {
                header: Librarian.Lang.getString("name"),
                labelFunction: Librarian.Utils.renderContactName,
                dataIndex: "lastname",
                dataType: "string",
                width: 225
            },
            {
                header: Librarian.Lang.getString("email"),
                dataIndex: "email",
                dataType: "string",
                width: 375
            }
        ];

        return columnModel;
    },

    loginOnBehalf: function(obj) {
        var data = this.grid.getDataByRow(obj.row);

        if (!data)
            return;

        var url = Librarian.path.getMethodUrl("logob") + "&obuid=" + data.userid;

        new Librarian.Request({
            url: url,
            onSuccess: function() {
                // Refresh the page once logged in
                location.reload(true);
            },
            onFailure: Librarian.Utils.onFailure
        }).send();

        this.close();
    }
});